<template>
  <ubi-panel v-if="getJob === 'AGENCE' || renderIfTypeOffre">
    <el-container>
      <el-main>
        <el-row :gutter="20">
          <el-col :span="6">
            <h3 style="margin-left: -30px;">{{ $t('posts.components.propertyAvailability')}}</h3>
          </el-col>
          <el-col :span="6" v-if="renderIfTypeOffre">
            <el-form-item :label="$t('posts.components.availabilityStartDate')">
              <el-date-picker format="dd/MM/yyyy"
                              value-format="dd/MM/yyyy"
                              v-model="post.date_disponibilite">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <!-- tache 112377: Ajouter la date de fin de disponibilité du bien, quelque soit le type d'offre et le type de bien sur l'outil de saisie en ligne.
Uniquement sur ce métier Immo ancien-->
          <el-col :span="6" v-if="getJob === 'AGENCE'">
            <el-form-item :label="$labels.date_fin_disponibilite">
              <el-date-picker format="dd/MM/yyyy"
                              value-format="dd/MM/yyyy"
                              v-model="post.date_fin_disponibilite">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </ubi-panel>
</template>

<script>

import UbiPanel from '@/components/Panel.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'FinDeDisponibilite',
  components: { UbiPanel },
  props: {
    post: Object
  },
  computed: {
    ...mapGetters(['getJob']),
    renderIfTypeOffre () {
      // Ancien composant où la date de disponibilité était visible
      const types = ['G', 'I', 'H', 'M', 'V', 'S', 'L', 'W', 'Z']
      return types.includes(this.post.typeOffre)
    }
  }
}
</script>

<style scoped>

</style>
